<template>
  <div class="header is-fixed">
    <div class="top-box flex_align_between">
      <div class="flex_align">
        <div class="img_box" @click="$router.push({ path: '/' })"></div>
        <span class="logo-desc">丨国际复合人才就业一站式服务平台</span>
      </div>
      <div class="flex_align top-box_right">
        <template v-for="(item, key) in nav_list">
          <router-link
            :to="{ name: item.path }"
            v-if="item.children.length <= 0"
            :key="key"
          >
            <div class="nav_item" :class="page == item.page ? 'on' : ''">
              <span>{{ item.title }}</span>
              <div class="t_s"></div>
            </div>
          </router-link>
          <el-dropdown v-else :key="key">
            <div class="nav_item" :class="page == item.page ? 'on' : ''">
              <span>{{ item.title }}</span>
              <div class="t_s"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(vo, key) in item.children" :key="key"
                ><router-link :to="{ name: vo.path }">{{
                  vo.title
                }}</router-link></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-dropdown v-if="isLogin">
          <div class="nav_item" :class="page == 5 ? 'on' : ''">
            <span>个人中心</span>
            <div class="t_s"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><router-link :to="{ name: 'profileIndex' }"
                >个人信息</router-link
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><router-link :to="{ name: 'profileCourse' }"
                >我的课表</router-link
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><router-link :to="{ name: 'profileTest' }"
                >我的测试</router-link
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><router-link :to="{ name: 'profileMessage' }"
                >系统消息</router-link
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else class="login-button" @click="open">登录/注册</div>
      </div>
    </div>
    <!-- <div class="bg"></div> -->
    <div class="mask" v-if="showLogin || showRegister || showForget">
      <div class="windows login_box1" v-show="showLogin">
        <div class="x el-icon-close" @click="showLogin = false"></div>
        <p class="login-nav">
          <span @click="loginType = 1" :class="loginType == 1 ? 'on' : ''"
            >短信快捷登录</span
          >
          <span @click="loginType = 2" :class="loginType == 2 ? 'on' : ''"
            >账号密码登录</span
          >
        </p>
        <el-form
          v-show="loginType == 2"
          ref="login_form"
          :model="login_form"
          :rules="loginRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="username">
            <span class="svg-container">
              <span class="icon">&#xe645;</span>
            </span>
            <el-input
              v-model="login_form.username"
              placeholder="请输入账号"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>

          <el-form-item prop="password">
            <span class="svg-container">
              <span class="icon">&#xe648;</span>
            </span>
            <el-input
              v-model="login_form.password"
              type="password"
              placeholder="请输入密码"
              tabindex="2"
              auto-complete="on"
            />
          </el-form-item>
          <div class="submitbtn" @click="login_submit">登录</div>
        </el-form>
        <el-form
          v-show="loginType == 1"
          ref="login_form_mobile"
          :model="login_form_mobile"
          :rules="loginMobileRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="mobile">
            <span class="svg-container">
              <span class="el-icon-phone-outline"></span>
            </span>
            <el-input
              v-model="login_form_mobile.mobile"
              placeholder="请输入手机号"
              type="tel"
              tabindex="1"
              auto-complete="on"
              style="width: 70%"
            />
            <el-button
              @click="sendemail_l"
              :loading="loading_l"
              :disabled="cannot_l"
              class="sendcode"
              >{{ countdetail_l }}</el-button
            >
          </el-form-item>
          <el-form-item prop="code">
            <span class="svg-container">
              <span class="icon">&#xe600;</span>
            </span>
            <el-input
              v-model="login_form_mobile.code"
              placeholder="请输入短信验证码"
              type="tel"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <div class="submitbtn" @click="login_submit_mobile">登录</div>
        </el-form>
        <div class="tips flex_align_between">
          <span @click="open1">忘记密码？</span
          ><span @click="open2">立即注册</span>
        </div>
      </div>
      <div class="windows login_box1" v-show="showForget">
        <div class="x el-icon-close" @click="showForget = false"></div>
        <p class="title">忘记密码</p>
        <el-form
          ref="forget_form"
          :model="forget_form"
          :rules="forgetRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="mobile">
            <span class="svg-container">
              <span class="el-icon-phone-outline"></span>
            </span>
            <el-input
              v-model="forget_form.mobile"
              placeholder="请输入手机号"
              type="tel"
              tabindex="1"
              auto-complete="on"
              style="width: 70%"
            />
            <el-button
              @click="sendemail_f"
              :loading="loading_f"
              :disabled="cannot_f"
              class="sendcode"
              >{{ countdetail_f }}</el-button
            >
          </el-form-item>
          <el-form-item prop="code">
            <span class="svg-container">
              <span class="icon">&#xe600;</span>
            </span>
            <el-input
              v-model="forget_form.code"
              placeholder="请输入短信验证码"
              type="tel"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="password">
            <span class="svg-container">
              <span class="icon">&#xe648;</span>
            </span>
            <el-input
              v-model="forget_form.password"
              placeholder="请输入密码"
              type="password"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="sure_password">
            <span class="svg-container">
              <span class="icon">&#xe648;</span>
            </span>
            <el-input
              v-model="forget_form.sure_password"
              placeholder="请再次输入密码"
              type="password"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <div class="submitbtn" @click="forget_submit">提交</div>
        </el-form>
      </div>
      <div class="windows login_box2" v-show="showRegister">
        <div class="x el-icon-close" @click="showRegister = false"></div>
        <p class="title">账号注册</p>
        <el-form
          ref="register_form"
          :model="register_form"
          :rules="registerRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="username">
            <span class="svg-container">
              <span class="icon">&#xe645;</span>
            </span>
            <el-input
              v-model="register_form.username"
              placeholder="请输入账号"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="nickname">
            <span class="svg-container">
              <span class="icon">&#xe647;</span>
            </span>
            <el-input
              v-model="register_form.nickname"
              placeholder="请输入昵称"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="age">
            <span class="svg-container">
              <span class="icon">&#xe64e;</span>
            </span>
            <el-input
              v-model="register_form.age"
              placeholder="请输入年龄"
              type="number"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="school">
            <span class="svg-container">
              <span class="icon">&#xe64b;</span>
            </span>
            <el-input
              v-model="register_form.school"
              placeholder="请输入学校"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="specialty">
            <span class="svg-container">
              <span class="icon">&#xe64c;</span>
            </span>
            <el-select
              v-model="register_form.specialty"
              multiple
              placeholder="请选择特长"
            >
              <el-option
                v-for="item in specialty_list"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mobile">
            <span class="svg-container">
              <span class="el-icon-phone-outline"></span>
            </span>
            <el-input
              v-model="register_form.mobile"
              placeholder="请输入手机号"
              type="tel"
              tabindex="1"
              auto-complete="on"
              style="width: 70%"
            >
            </el-input>
            <el-button
              @click="sendemail_r"
              :loading="loading_r"
              :disabled="cannot_r"
              class="sendcode"
              >{{ countdetail_r }}</el-button
            >
          </el-form-item>
          <el-form-item prop="code">
            <span class="svg-container">
              <span class="icon">&#xe600;</span>
            </span>
            <el-input
              v-model="register_form.code"
              placeholder="请输入短信验证码"
              type="tel"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="password">
            <span class="svg-container">
              <span class="icon">&#xe648;</span>
            </span>
            <el-input
              v-model="register_form.password"
              placeholder="请输入密码"
              type="password"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <el-form-item prop="sure_password">
            <span class="svg-container">
              <span class="icon">&#xe648;</span>
            </span>
            <el-input
              v-model="register_form.sure_password"
              placeholder="请再次输入密码"
              type="password"
              tabindex="1"
              auto-complete="on"
            />
          </el-form-item>
          <div class="submitbtn" @click="register_submit">完成注册</div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../bus/bus.js";
export default {
  props: {
    is_index: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logo: require("@/assets/img/logo.png"),
      logo_w: require("@/assets/img/logo_w.png"),
      page: 1,
      showLogin: false,
      showRegister: false,
      showForget: false,
      loginType: 1,
      login_form: {},
      loginRules: {
        username: [
          {
            required: true,
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            trigger: "change",
          },
        ],
      },
      login_form_mobile: {},
      loginMobileRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change",
          },
        ],
      },
      forget_form: {},
      forgetRules: {
        mobile: [
          {
            message: "请输入手机号",
            required: true,
            trigger: "change",
          },
        ],
        code: [
          {
            message: "请输入验证码",
            required: true,
            trigger: "change",
          },
        ],
        password: [
          {
            message: "请输入密码",
            required: true,
            trigger: "change",
          },
        ],
        sure_password: [
          {
            message: "请确认密码",
            required: true,
            trigger: "change",
          },
        ],
      },
      registerRules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "change",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入昵称",
            trigger: "change",
          },
        ],
        age: [
          {
            required: true,
            message: "请输入年龄",
            trigger: "change",
          },
        ],
        school: [
          {
            required: true,
            message: "请输入学校",
            trigger: "change",
          },
        ],
        specialty: [
          {
            required: true,
            message: "请选择特长",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
        ],
        sure_password: [
          {
            required: true,
            message: "请确认密码",
            trigger: "change",
          },
        ],
      },
      register_form: {
        age: "",
        school: "",
        specialty: [],
        mobile: "",
        password: "",
        sure_password: "",
        code: "",
      },
      //注册
      countdetail_r: "发送",
      cannot_r: false,
      loading_r: false,
      //登录
      countdetail_l: "发送",
      cannot_l: false,
      loading_l: false,
      //忘记密码
      countdetail_f: "发送",
      cannot_f: false,
      loading_f: false,

      specialty_list: [],
      isLogin: false,
      nav_list: [],
    };
  },
  created() {
    this.getSpecialty();
    bus.$on("showLogin", (res) => {
      this.showLogin = res;
    });
    this.getnav();
  },
  mounted() {
    if (localStorage.getItem("grts_token")) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  watch: {
    $route(to) {
      this.page = to.meta.page;
      if (localStorage.getItem("grts_token")) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
  },
  methods: {
    getnav() {
      this.$myAjax(
        "/student/common/nav",
        "get",
        {},
        (response) => {
          this.nav_list = response;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getSpecialty() {
      this.$myAjax(
        "student/login/getSpecialty",
        "get",
        {},
        (response) => {
          this.specialty_list = response;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    sendemail_r() {
      if (this.register_form.mobile) {
        this.$myAjax(
          "student/login/getCode",
          "post",
          {
            mobile: this.register_form.mobile,
            action: "register",
          },
          () => {
            this.$message({
              showClose: true,
              message: "发送成功",
              type: "success",
            });
            let count = 60;
            this.loading_r = true;
            this.cannot_r = true;
            var interval = setInterval(() => {
              this.loading_r = false;
              count--;
              if (count == 0) {
                clearInterval(interval);
                this.countdetail_r = "发送";
                this.cannot_r = false;
              } else {
                this.countdetail_r = count + "s";
              }
            }, 1000);
          }
        );
      } else {
        this.$message({
          showClose: true,
          message: "请先填写手机号码",
          offset: 170,
        });
      }
    },
    sendemail_l() {
      if (this.login_form_mobile.mobile) {
        this.$myAjax(
          "student/login/getCode",
          "post",
          {
            mobile: this.login_form_mobile.mobile,
            action: "login",
          },
          () => {
            this.$message({
              showClose: true,
              message: "发送成功",
              type: "success",
            });
            let count = 60;
            this.loading_l = true;
            this.cannot_l = true;
            var interval = setInterval(() => {
              this.loading_l = false;
              count--;
              if (count == 0) {
                clearInterval(interval);
                this.countdetail_l = "发送";
                this.cannot_l = false;
              } else {
                this.countdetail_l = count + "s";
              }
            }, 1000);
          }
        );
      } else {
        this.$message({
          showClose: true,
          message: "请先填写手机号码",
        });
      }
    },
    sendemail_f() {
      if (this.forget_form.mobile) {
        this.$myAjax(
          "student/login/getCode",
          "post",
          {
            mobile: this.forget_form.mobile,
            action: "forget",
          },
          () => {
            this.$message({
              showClose: true,
              message: "发送成功",
              type: "success",
            });
            let count = 60;
            this.loading_f = true;
            this.cannot_f = true;
            var interval = setInterval(() => {
              this.loading_f = false;
              count--;
              if (count == 0) {
                clearInterval(interval);
                this.countdetail_f = "发送";
                this.cannot_f = false;
              } else {
                this.countdetail_f = count + "s";
              }
            }, 1000);
          }
        );
      } else {
        this.$message({
          showClose: true,
          message: "请先填写手机号码",
        });
      }
    },
    open() {
      this.loginType = 1;
      this.showLogin = true;
    },
    open1() {
      this.showLogin = false;
      this.showForget = true;
    },
    open2() {
      this.showLogin = false;
      this.showRegister = true;
    },
    register_submit() {
      let that = this;
      this.$refs.register_form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "注册中，请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          localStorage.removeItem("grts_User");
          let data = JSON.parse(JSON.stringify(this.register_form));
          data.specialty = data.specialty.join(",");
          this.$myAjax(
            "student/login/register",
            "post",
            data,
            function (data) {
              loading.close();
              that.$message({
                type: "success",
                message: "注册成功，已自动登录 ... ...",
              });
              localStorage.setItem("grts_token", data.token);
              that.showRegister = false;
              setTimeout(function () {
                // that.$router.push({ name: "profileIndex" });
                location.reload();
              }, 1000);
            },
            function () {
              loading.close();
            }
          );
        }
      });
    },
    login_submit() {
      let that = this;
      this.$refs.login_form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "登录中，请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          localStorage.removeItem("grts_User");
          this.$myAjax(
            "student/login/accountLogin",
            "post",
            this.login_form,
            function (data) {
              console.log(data);
              loading.close();
              that.$message({
                type: "success",
                message: "登录成功 ... ...",
              });
              localStorage.setItem("grts_token", data.token);
              that.showLogin = false;
              setTimeout(function () {
                // that.$router.push({ name: "profileIndex" });
                location.reload();
              }, 1000);
            },
            function () {
              loading.close();
            }
          );
        }
      });
    },
    login_submit_mobile() {
      let that = this;
      this.$refs.login_form_mobile.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "登录中，请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          localStorage.removeItem("grts_User");
          this.$myAjax(
            "student/login/mobileLogin",
            "post",
            this.login_form_mobile,
            function (data) {
              loading.close();
              that.$message({
                type: "success",
                message: "登录成功 ... ...",
              });
              localStorage.setItem("grts_token", data.token);
              that.showLogin = false;
              setTimeout(function () {
                // that.$router.push({ name: "profileIndex" });
                location.reload();
              }, 1000);
            },
            function () {
              loading.close();
            }
          );
        }
      });
    },
    forget_submit() {
      let that = this;
      this.$refs.forget_form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "提交中，请稍后...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.$myAjax(
            "student/login/forget",
            "post",
            this.forget_form,
            function () {
              loading.close();
              that.$message({
                type: "success",
                message: "修改成功，去登陆 ... ...",
              });
              that.showForget = false;
              that.showLogin = true;
            },
            function () {
              loading.close();
            }
          );
        }
      });
    },
  },
};
</script>
<style lang="scss">
.login-form {
  .el-select {
    width: 90%;
    .el-input {
      width: 100%;
    }
  }
  .el-input {
    display: inline-block;
    height: 40px;
    width: 90%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #929ba8;
      height: 40px;
    }
  }
  .el-form-item {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e4e8ee;
    border-radius: 8px;
  }
  .svg-container {
    padding: 0px 5px 6px 15px;
    color: #4265d6;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .el-form-item__content {
    height: 40px;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
</style>
<style lang="scss" scoped>
a:active,
a:visited {
  color: unset;
}
.header {
  height: 50px;
  width: 100%;
  box-shadow: 0px 0px 5px 5px #f5f6f8;
  background-color: #fff;
  z-index: 99;
  font-size: 16px;
  .top-box {
    height: 50px;
    padding: 0 40px;
    .img_box {
      cursor: pointer;
      width: 200px;
      height: 26px;
      background: url("~@/assets/img/logo.png");
      background-size: 100% auto;
    }
    .logo-desc {
      word-break: keep-all;
    //   color: #fff;
    }
    .top-box_right {
      div.nav_item {
        margin: 0 10px;
        position: relative;
        // color: #fff;
        font-size: 16px;
        .t_s {
          width: 0;
          height: 1px;
            background: #263e8b;
        //   background: #fff;
          bottom: -10px;
          left: 0;
          right: 0;
          position: absolute;
          margin: 0;
        }
        &:hover {
          .t_s {
            width: 100%;
            transition: all 0.5s;
          }
        }
        &.on {
          //   color: #263e8b;
          .t_s {
            width: 100%;
          }
        }
      }
      .login-button {
        width: 90px;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(90deg, #4a9eff 0%, #2f4fed 100%);
        border-radius: 30px;
        color: #fff;
        text-align: center;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
}
.is-fixed {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
}
.index-header {
  backdrop-filter: blur(10px);
  background: rgba(61, 59, 59, 0.5);
  //   position: absolute;
  box-shadow: none;
  .bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background: #fff;
  }
}
.project-header ,.index-header{
  backdrop-filter: blur(10px);
  //   background: rgb(0 0 0 / 30%);
  background: rgba(61, 59, 59, 0.5);
  //   position: absolute;
  z-index: 3;
  box-shadow: none;
  color: rgb(255 255 255 / 80%);
  &.header {
    .img_box {
      background: url("~@/assets/img/logo_w.png");
      background-size: 100% auto;
    }
  }
  a {
    color: #fff;
  }
  .top-box_right {
    div.nav_item {
      span {
        color: rgb(255 255 255 / 80%);
      }
      .t_s {
        background: #fff !important;
      }
      &.on {
        font-weight: bold;
        color: #fff !important;
      }
    }
  }
}
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  left: 0;
  top: 0;
  z-index: 2000;
  .windows {
    width: 420px;
    background: #fff;
    top: 50%;
    left: 50%;
    margin-left: -210px;
    margin-top: -300px;
    position: relative;
    border-radius: 20px;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    z-index: 99;
    padding-bottom: 30px;
    .login-nav {
      margin-bottom: 20px;
      span {
        display: inline-block;
        width: 50%;
        text-align: center;
        height: 40px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 40px;
        color: #929ba8;
        cursor: pointer;
        &.on {
          background: #e4e8ee;
          opacity: 1;
          border-radius: 5px;
          color: #4265d6;
        }
      }
    }
    .tips {
      margin-top: 20px;
      span {
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 20px;
        color: #929ba8;
        cursor: pointer;
      }
    }
    .x {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 18px;
      color: #111;
      cursor: pointer;
    }
    p {
      margin-top: 20px;
      color: #000000;
      font-size: 16px;
      text-align: center;
    }
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .submitbtn {
      margin-top: 20px;
      width: 100%;
      height: 40px;
      background: linear-gradient(90deg, #4a9eff 0%, #2f4fed 100%);
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      cursor: pointer;
      color: #fff;
      border-radius: 10px;
    }
  }
  .sendcode {
    height: 32px;
    background: linear-gradient(90deg, #4a9eff 0%, #2f4fed 100%);
    border-radius: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 32px;
    color: #ffffff;
    display: block;
    float: right;
    margin: 4px;
    width: 60px;
    text-align: center;
    padding: 0;
  }
}
</style>
